import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'studio-components';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { ProjectSummary } from 'src/app/store/project/models/project-summary.model';

@Component({
  selector: 'app-project-undeploy-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule],
  templateUrl: './project-undeploy-dialog.component.html',
})
export class ProjectUndeployDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ProjectUndeployDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ProjectSummary,
  ) {}

  public confirm() {
    this.dialogRef.close(true);
  }

  public cancel() {
    this.dialogRef.close(false);
  }
}
